import { DOMAINS } from '../../shared/constants/Miscellaneous.constants';

import useSiteMetadata from './useSiteMetadata';

const isInternalLink = (fullLinkUrl?: string) => {
  if (!fullLinkUrl) return false;
  const { siteUrl } = useSiteMetadata();

  return ['/', siteUrl, DOMAINS.production, DOMAINS.staging, DOMAINS.open].some(
    (internalUrl) => fullLinkUrl.startsWith(internalUrl)
  );
};

export default isInternalLink;
